/*    
<summary>
  This functional component shows the fota device status scheduler details.
  Developer:Aashish Singh, Created Date: 08-July-2025
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IFotaDevicesStatusList } from "../../../models/response/IFotaSchedulerDevicesResponse";
import TerminationTypeEnum from "../../../constants/termination-type-enum";
import { emptyValueHyphen } from "../../../constants/common-constants";
import FotaStatusEnum from "../../../constants/fota-status-enum";

interface IProps {
  selectedData: null | IFotaDevicesStatusList;
}

const FotaDeviceStatusDetails = (props: IProps) => {
  const { selectedData } = props;
  return (
    <React.Fragment>
      {selectedData && selectedData !== null && (
        <div className="p-3">
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="iccid" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{selectedData.ICCID}</span>
              </p>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="status" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{selectedData.StatusValue}</span>
              </p>
            </div>
          </div>
          {
            (selectedData.StatusValue === FotaStatusEnum[FotaStatusEnum.Aborted] || selectedData.StatusValue === FotaStatusEnum[FotaStatusEnum.Failed]) &&
            <>
              {/* <div className="row pt-2">
                <div className="col-6">
                  <label className="text-muted bold">
                    <FormattedMessage id="termination_type_value" />:{" "}
                  </label>
                </div>
                <div className="col-6">
                  <p className="mw-100">
                    <span>{selectedData.TerminationTypeValue !== TerminationTypeEnum[TerminationTypeEnum.None] ? <FormattedMessage id={selectedData.TerminationTypeValue} /> : emptyValueHyphen}</span>
                  </p>
                </div>
              </div> */}
              <div className="row pt-2">
                <div className="col-6">
                  <label className="text-muted bold">
                    <FormattedMessage id="termination_date_timestamp" />:{" "}
                  </label>
                </div>
                <div className="col-6">
                  <p className="mw-100">
                    <span>{selectedData.TerminationDateTimestamp}</span>
                  </p>
                </div>
              </div>
              <div className="row pt-2">
                <div className="col-6">
                  <label className="text-muted bold">
                    <FormattedMessage id="termination_reason_remark" />:{" "}
                  </label>
                </div>
                <div className="col-6">
                  <p className="mw-100">
                    <span>{selectedData.TerminationReasonRemark}</span>
                  </p>
                </div>
              </div>
            </>
          }
        </div>
      )}
    </React.Fragment>
  );
};

export default observer(FotaDeviceStatusDetails);
